import { useDispatch } from "react-redux"
import { setHour } from "../../../stateManagement/reducers/services/weatherStations/WeatherStationsSlice"
import { useAppSelector } from "../../../stateManagement/hooks/redux"

const weatherCloudIconSrc = require('../../../assets/images/icons/weather/weather_cloud.svg').default
const weatherRainIconSrc = require('../../../assets/images/icons/weather/weather_rain.svg').default
const weatherSnowIconSrc = require('../../../assets/images/icons/weather/weather_snow.svg').default
const weatherSleetIconSrc = require('../../../assets/images/icons/weather/weather_sleet.svg').default
const weatherHailIconSrc = require('../../../assets/images/icons/weather/weather_hail.svg').default
const weatherUnknownIconSrc = require('../../../assets/images/icons/weather/weather_unknown.svg').default

type PrecipitationType = "cloudy" | "rainy" | "snowy" | "sleet" | "hail" | "unknown";

type HourMeasurementProps = {
    data: {
        hour: number,
        temperature: number | null,
        precipitationTypeValue: number
    },
    activeRef: any
}

export const WEATHER_CONDITIONS: Record<PrecipitationType, {}> = {
    cloudy: {
        iconSrc: weatherCloudIconSrc,
        caption: "Облачность",
        code: 0
    },
    rainy: {
        iconSrc: weatherRainIconSrc,
        caption: "Дождь",
        code: 1
    },
    snowy: {
        iconSrc: weatherSnowIconSrc,
        caption: "Снег",
        code: 2
    },
    sleet: {
        iconSrc: weatherSleetIconSrc,
        caption: "Снег с дождем",
        code: 3
    },
    hail: {
        iconSrc: weatherHailIconSrc,
        caption: "Град",
        code: 4
    },
    unknown: {
        iconSrc: weatherUnknownIconSrc,
        caption: "Нет информации",
        code: 255
    },
}

export default function HourMeasurementItem({ data: { hour, temperature, precipitationTypeValue }, activeRef }: HourMeasurementProps) {

    const dispatch = useDispatch();
    const selectedHour = useAppSelector(state => state.weatherStationsService.hour)
    let iconSrc = weatherUnknownIconSrc;
    if (precipitationTypeValue != null) {
        iconSrc = Object.values(WEATHER_CONDITIONS).find((wc) => wc?.code === precipitationTypeValue)?.iconSrc
    }

    return (
        <div ref={activeRef} className={'hour-measurement-item-div' + (selectedHour === hour ? ' active' : '')} onClick={() => dispatch(setHour(hour))}>
            <div className="time-text">{hour}:00</div>
            <img src={iconSrc} alt="WeatherCondition"/>
            <div className="temp-text">{temperature != null ? `${temperature}°C` : '?'}</div>
        </div>
    )
}
